import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./Region.css";

const url = process.env.REACT_APP_BACKEND_URL;

const RegionForm = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const isEdit = !!id;

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  // const [description, setDescription] = useState("");
  // const [code, setCode] = useState("");

  const [countries, setCountries] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchCountries = async () => {

      try {

        const res = await axios.get(`${url}/api/country`);

        setCountries(res.data.data || []);

      } catch {
        toast.error("Failed to load countries");
      }

    };

    fetchCountries();

  }, []);

  useEffect(() => {

    if (!isEdit) return;

    const fetchRegion = async () => {

      try {

        const res = await axios.get(`${url}/api/Regions/${id}`);

        const r = res.data.data;

        setName(r.name);
        setCountry(r.country?._id || "");
        // setDescription(r.description || "");
        // setCode(r.code || "");

      } catch {
        toast.error("Failed to load region");
      }

    };

    fetchRegion();

  }, [id]);

  const handleSubmit = async (e) => {

    e.preventDefault();

    const payload = { name, country};

    try {

      setLoading(true);

      if (isEdit) {

        await axios.put(`${url}/api/Regions/${id}`, payload);

        toast.success("Region updated");

      } else {

        await axios.post(`${url}/api/Regions`, payload);

        toast.success("Region created");
      }

      navigate("/regions");

    } catch (err) {

      toast.error(err.response?.data?.message || "Operation failed");

    } finally {
      setLoading(false);
    }

  };

  return (

    <div className="region-container">

      <h2>{isEdit ? "Edit Region" : "Add Region"}</h2>

      <form onSubmit={handleSubmit} className="region-form">

        <div className="form-group">
          <label>Region Name</label>
          <input value={name} onChange={(e)=>setName(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Country</label>
          <select value={country} onChange={(e)=>setCountry(e.target.value)} required>
            <option value="">Select Country</option>
            {countries.map(c=>(
              <option key={c._id} value={c._id}>{c.name}</option>
            ))}
          </select>
        </div>

        {/* <div className="form-group">
          <label>Code</label>
          <input value={code} onChange={(e)=>setCode(e.target.value)} />
        </div> */}

        {/* <div className="form-group">
          <label>Description</label>
          <input value={description} onChange={(e)=>setDescription(e.target.value)} />
        </div> */}

        <div className="form-actions">

          <button className="submit-button">
            {loading ? "Processing..." : isEdit ? "Update Region" : "Save Region"}
          </button>

          <button
            type="button"
            onClick={()=>navigate("/regions")}
            className="cancel-button"
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
};

export default RegionForm;